import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { fetchPost } from '../../../store/fetch';
import { Modal } from '../../common/Modal/Modal';
import {
    EditPanelButton,
    EditPanelButtons,
    EditPanelCell,
    EditPanelRow,
    EditPanelSection,
    EditPanelSelect,
    EditPanelSwitch,
    Panel,
    PanelBody,
} from '../../elements';
import { IUtProject } from '../Interfaces/IUtProject';

// const fetchPostMergeProject = async (targetProjectId: string, sourceProjectId: string, overwriteScanlines: boolean) => {
//     await fetchPost(`/api/utprojects/${targetProjectId}/merge`, { sourceProjectId, overwriteScanlines: overwriteScanlines ? 'true' : 'false'});
// };

export function MergeProject(props: { projectId: string; projectName: string; projects: IUtProject[]; onMerged: () => void }) {
    // const translate = useTranslate();
    const [isMergeProjectDialogVisible, setIsMergeProjectDialogVisible] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);

    const selectionProjects = props.projects.filter((item) => item.id !== props.projectId);

    const mergeProject = async (selectedProjectId: string, shouldMergeScanLines: boolean, shouldOverwriteMeasurements: boolean) => {
        setIsMergeProjectDialogVisible(false);
        setIsLoading(true);
        await fetchPost(`/api/utprojects/${selectedProjectId}/merge`, {
            sourceProjectId: props.projectId,
            scanLines: shouldMergeScanLines ? 'true' : 'false',
            overwrite: shouldOverwriteMeasurements ? 'true' : 'false',
        });
        setIsLoading(false);
        props.onMerged();
    };

    return (
        <>
            <EditPanelButton text="Merge project" small onClick={() => setIsMergeProjectDialogVisible(true)} disabled={isLoading} />
            {isMergeProjectDialogVisible && (
                <ProjectSelect
                    projects={selectionProjects}
                    projectName={props.projectName}
                    onClose={() => setIsMergeProjectDialogVisible(false)}
                    onMerge={mergeProject}
                />
            )}
        </>
    );
}

function ProjectSelect(props: {
    projects: IUtProject[];
    projectName: string;
    onClose: () => void;
    onMerge: (projectId: string, mergeScanlines: boolean, overwrite: boolean) => void;
}) {
    const translate = useTranslate();
    const [selectedProjectId, setSelectedProjectId] = React.useState('');
    const [isOverwrite, setIsOverwrite] = React.useState(false);
    const [isMergeScanLines, setIsMergeScanLines] = React.useState(true);

    const handleSaveProject = () => {
        if (selectedProjectId) {
            props.onMerge(selectedProjectId, isMergeScanLines, isOverwrite);
        }
    };

    const handleCloseFormClicked = () => {
        props.onClose();
    };

    return (
        <Modal id="copy-dialog" onClose={() => handleCloseFormClicked()}>
            <Modal.Title>
                <h3>
                    <span className="panel-title">Select project to merge into</span>
                </h3>
            </Modal.Title>
            <Modal.Content style={{ height: '300px' }}>
                <form method="post" action="/" id="admin-form">
                    <div>Pay attention!</div>
                    <div className="mb20">
                        The measurements of &quot;{props.projectName}&quot; are added and renumbered in the selected project. Renumbering will not
                        happen when &quot;Overwrite when merging&quot; was selected. The project &quot;{props.projectName}&quot; will be removed. The
                        numbering of the selected project remains unchanged.
                        <br />
                        For more explanation and examples,{' '}
                        <a target="_blank" href="/assets/docs/Examples_merge_ut_data.pdf">
                            see this document
                        </a>
                        .
                    </div>
                    <Panel>
                        <PanelBody>
                            <EditPanelSection>
                                <EditPanelSelect
                                    name="inspectionStandardType"
                                    value={selectedProjectId}
                                    handleChange={(value) => setSelectedProjectId(value)}
                                    placeholder={translate('common.selectItem', 'Project')}
                                    options={props.projects.map((item: IUtProject) => ({ value: item.id, text: item.name }))}
                                />
                            </EditPanelSection>
                            <EditPanelRow>
                                <EditPanelCell rowCount={6}>
                                    <EditPanelSwitch
                                        name="scanLine"
                                        placeholder="Merge scan lines"
                                        value={isMergeScanLines}
                                        handleChange={() => setIsMergeScanLines(!isMergeScanLines)}
                                    />
                                </EditPanelCell>
                                <EditPanelCell rowCount={6}>
                                    <EditPanelSwitch
                                        name="overwrite"
                                        placeholder="Overwrite when merging"
                                        value={isOverwrite}
                                        handleChange={() => setIsOverwrite(!isOverwrite)}
                                    />
                                </EditPanelCell>
                            </EditPanelRow>
                        </PanelBody>
                    </Panel>
                </form>
            </Modal.Content>
            <Modal.Actions>
                <EditPanelButtons fixWidth={true}>
                    <EditPanelButton small={true} text={translate('common.close')} onClick={() => handleCloseFormClicked()} />
                    <EditPanelButton small={true} text="Merge" onClick={() => handleSaveProject()} primary />
                </EditPanelButtons>
            </Modal.Actions>
        </Modal>
    );
}
